import { Nilable } from "@shared/utils";

export class IBatchDTO {
    id: number;
    project_name: string;
    research: number;
    author: Nilable<string>;
    created_at: Nilable<string>;
}

export class BatchDTO {
    public id = 0;
    public projectName = "";
    public investigacion = 0;
    public autor = "";
    public fechaCreacion: Nilable<Date> = null;

    constructor(json: Nilable<Partial<IBatchDTO>> = null) {
        if (json != null) {
            this.cargarJSON(json);
        }
    }

    public cargarJSON(json: Partial<IBatchDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.project_name != null) {
            this.projectName = json.project_name;
        }
        if (json.research != null) {
            this.investigacion = json.research;
        }
        if (json.author != null) {
            this.autor = json.author;
        }
        if (json.created_at != null) {
            this.fechaCreacion = new Date(json.created_at);
        }
    }

    public toJSON(): IBatchDTO {
        return {
            id: this.id,
            project_name: this.projectName,
            research: this.investigacion,
            author: this.autor,
            created_at: this.fechaCreacion?.toISOString() ?? null
        };
    }
}
